module.exports = __webpack_public_path__ + "img/bottom.d96c8506.jpg";